module.exports = __webpack_public_path__ + "img/1x.ca8c14b.jpg";